import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useAuth from 'customHook/useAuth'
import { Menu, Title, Item, Logout } from './styles'
import Cross from 'assets/svg/cross.svg'

const AccountNav = ({
  popUpRef,
  open,
  setOpen
}) => {

  const navigate = useNavigate();
  const { userLogout } = useAuth();
  const { pathname } = useLocation();

  return (
    <Menu open={open} ref={popUpRef}>
      <Title>
        <img
          src={Cross}
          alt="cross"
          onClick={()=>{
            setOpen(false)
          }}
        />
      </Title>
        <Item
          active={pathname==='/profile'}
          href='https://pms.rookhotel.com/profile'
          rel='noopener noreferrer'
          onClick={(event) => {
            // Handle special key combinations (Ctrl/Cmd+click)
            if (event.metaKey || event.ctrlKey) {
              // Allow default behavior (opens in new tab)
              return;
            }
            
            // Prevent default anchor behavior (full page reload)
            event.preventDefault();
            
            // Perform client-side navigation
            navigate('/profile');
          }}
        >
          PROFILE
        </Item>
      <Logout
        onClick={userLogout}
      >
        LOG OUT
      </Logout>
    </Menu>
  );
};

export default AccountNav;
